import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SECTIONS } from "@/lib/sections";
import { CompanySearch } from "@/components/site/CompanySearch";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.06, ease: "easeOut" },
  }),
};

/** Homepage hero: headline, hero search bar and per-section coverage counts. */
export function HomeHero({ counts }) {
  return (
    <section className="relative border-b border-kira-border overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.09),transparent_55%)]" />
      <div className="absolute inset-0 opacity-[0.04] [background-image:linear-gradient(rgba(255,255,255,0.9)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.9)_1px,transparent_1px)] [background-size:24px_24px]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={0}
          className="font-mono text-xs uppercase tracking-[0.28em] text-kira-gold mb-5"
        >
          KIRA Score — India&apos;s Equity Scoring Desk
        </motion.p>
        <motion.h1
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={1}
          className="font-chivo text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] mb-5 max-w-3xl"
        >
          Research Before<br />
          <span className="text-kira-gold">Returns.</span>
        </motion.h1>
        <motion.p
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={2}
          className="text-kira-textMuted text-base md:text-lg max-w-2xl mb-10"
        >
          Search any Indian company, unlisted business, upcoming IPO or commodity — every one
          distilled into a single institutional-grade KIRA Score.
        </motion.p>
        <motion.div variants={fadeUp} initial="hidden" animate="show" custom={3}>
          <CompanySearch variant="hero" />
        </motion.div>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          custom={4}
          className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[11px] uppercase tracking-[0.2em] text-kira-textMuted"
        >
          {SECTIONS.map((s) => (
            <Link key={s.key} to={`/research/${s.key}`} className="hover:text-kira-gold transition-colors">
              {s.short} · {counts[s.key] ?? 0}
            </Link>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
